/**
 * Non-hook util for the next-gen workspaces feature flag.
 * The value is cached from useIsNgwEnabled results.
 */

let cachedEnabled = false;

export function setNgwEnabled(value: boolean): void {
  cachedEnabled = value;
}

export function isNgwEnabled(): boolean {
  return cachedEnabled;
}
